import { compose, withHandlers, withProps } from 'recompose';

import { withModals } from 'ha/modules/ModalsLogic';
import SearchAlertButton from './SearchAlertButton';
import { MobileSearchAlertModalName } from '../../constants';

const enhance = compose(
  withProps({ isMobile: true }),
  withModals({ name: MobileSearchAlertModalName }),
  withHandlers({
    onClick: props => () => {
      if (!props.isModalOpen) {
        props.handleOpen();
      }
    },
  }),
);

export default enhance(SearchAlertButton);
